/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AutobuildTemplateOptions = core.serialization.object({
    namespace: core.serialization.string().optional(),
    autobuildId: core.serialization.string(),
});
